import { TSortDirections } from './../../../shared/services/list-services/sort-and-filter.service';
import { SortAndFilterService, Direction } from 'Src/ng2/shared/services/list-services/sort-and-filter.service';
import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { IStateService } from 'angular-ui-router';
import { filter, find, groupBy, includes, map, orderBy, replace } from 'lodash';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SpinnerModal } from 'Src/app/shared/modals/status-spinner/status-spinner.service';
import { IPageHeaderMeta } from 'Src/ng2/shared/components/header/page-header/page-header-meta.interface';
import { FixedToInfiniteViewComponent } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.component';
import { unsubscribeComponent } from 'Src/ng2/shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { ModalsService } from 'Src/ng2/shared/modals/modals.service';
import { ISyncedSheetModalPayload } from 'Src/ng2/shared/modals/other-tools/synced-sheet/synced-sheet-modal.component';
import { IColumnStuLvl, IGroupData, IListConfig, IRowData } from 'Src/ng2/shared/models/list-models';
import { DateHelpers } from 'Src/ng2/shared/services/date-helpers/date-helpers.service';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { UtilitiesService } from 'Src/ng2/shared/services/utilities/utilities.service';
import { WindowRef } from 'Src/ng2/shared/services/windowRef';
import { ISchool, TValidSchoolTypes } from 'Src/ng2/shared/typings/interfaces/school.interface';
import { IStudent } from 'Src/ng2/shared/typings/interfaces/student.interface';
import { ITool } from 'Src/ng2/shared/typings/interfaces/tool.interface';
import { IUser } from 'Src/ng2/shared/typings/interfaces/user.interface';
import { ImTool } from '../../../../app/shared/static-models/im-models/im-tool';
import {
  COLUMNS,
  SHEET_COLUMNS,
  SHEET_TYPE_MAPPINGS,
  DASH_TO_HUMAN,
  HUMAN_TO_DASH,
  IInternalView,
} from '../other-tools/other-tools.constant';
import { SYNC_ENABLED_DOMAINS } from '../school-tools-list/sync.constant';
import { ISchoolAssessment } from 'Src/ng2/shared/typings/interfaces/school-assessment.interface';

export interface ISyncToolGroupings {
  ATTENDANCE?: ITool[];
  'MARKING PERIOD'?: ITool[];
  'MOCK REGENTS'?: ITool[];
  'REGENTS APPEALS'?: ITool[];
  'REGENTS OUTREACH'?: ITool[];
  'REGENTS RESULTS'?: ITool[];
  SORTER?: ITool[];
  'SPELL MANAGEMENT'?: ITool[];
  SYNCED_LIST?: ITool[];
  'REMOTE LEARNING'?: ITool[];
}
export interface ISync {
  sheetName: string;
  normalizedSheetName: string;
  sheetCreator: string;
  sheetCreatorLowerCase: string;
  createdDate: string;
  normalizedCreatedDate: string;
  sheetLink?: string;
  sheetId?: string;
  ownByCurrentUser: boolean;
  pending?: boolean;
  schoolYear: string;
}
export interface IToolMini {
  label: string;
  url: string;
  schoolYear: string;
  groupName: string;
  createdOn: string;
}

export interface IExternalView {
  tools: ITool[];
  currentUser: IUser;
  internalViews: IInternalView[];
  canAccessSync: boolean;
}

const hsInternalViews: IInternalView[] = [
  {
    label: `Next term planning`,
    state: `main.school.other-tools.next-term-planning`,
  },
  {
    label: `Program changes`,
    state: `main.school.other-tools.program-changes-and-gap-plans`,
  },
];

@unsubscribeComponent
@Component({
  selector: 'other-tools',
  template: require('./other-tools.component.html'),
  styles: [require('./other-tools.component.scss')],
})
export class OtherToolsComponent extends FixedToInfiniteViewComponent implements OnInit {
  @Input() currentUser: IUser;
  @Input() tools$: Observable<ITool[]>;
  @Input() students$: Observable<IStudent[]>;
  @Input() currentSchool: ISchool;
  @Input() schoolAssessments$: Observable<ISchoolAssessment[]>;

  @ViewChild('entry', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;
  @ViewChild('listContent', { static: false }) listContent;
  groupingData$ = new BehaviorSubject<IGroupData[]>(null);
  currentSelection: string;
  currentOptions: ISync[];
  toolsSubscription: Subscription;
  groupedTools: ISyncToolGroupings;
  syncedSheetsSelected: boolean = true;
  programChangesSelected: boolean = false;
  nextTermPSelected: boolean = false;
  showShadow: boolean = false;
  batchActionsMode$ = of(false);
  columnIndexMap: { [key: string]: number };
  pageHeaderMeta: IPageHeaderMeta;
  toolNameHuman: string;
  students: IStudent[];
  columns: IColumnStuLvl[];
  noDataMessage = 'No synced sheets have been created yet';
  // inherited abstract members from FixedToInfiniteViewComponent
  // not in use here, but must be declared
  groupData$;
  dynamicColumnIndexMap;
  dynamicColumns;
  onDynamicComponentClick;
  maximumVisibleRowsPerGroup: Number;
  schoolId: string;
  studentsSubscription;
  modalSubscription;
  syncedSheetColModalSub;
  public listConfig: IListConfig = {
    listType: 'SHEETS',
    noDataMessage: 'No synced sheets have been created yet',
    sortableColumns: true,
  };
  public onUiRowDataUpdate: Function = () => null;

  public filterFormControl: FormControl;
  public sortKey$: BehaviorSubject<string>;
  public sortDirection$: BehaviorSubject<TSortDirections>;
  public updateSort: Function;

  // super methods
  onFixed: Function;
  onInfinite: Function;
  onRowClick: Function;
  onBatchAction: Function;

  public internalViews: IInternalView[];
  public canAccessSync: boolean;
  public hasTools: boolean;
  public sheetTools: IToolMini[];
  public readySyncs: ISync[] = [];
  public pendingSyncs: ISync[] = [];
  public groupings: IGroupData[];
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private imUser: ImUser,
    private utilitiesService: UtilitiesService,
    private dateHelpers: DateHelpers,
    public resolver: ComponentFactoryResolver,
    private modalsService: ModalsService,
    private windowRef: WindowRef,
    @Inject('ImTool') private imTool: ImTool,
    @Inject('SpinnerModal') private spinnerModal: SpinnerModal,
    @Inject('$state') private $state: IStateService,
    @Inject('$stateParams') private $stateParams,
  ) {
    super(resolver);
  }

  ngOnInit(): void {
    this.filterFormControl = new FormControl(null);
    this.sortKey$ = new BehaviorSubject('CREATED_ON');
    this.sortDirection$ = new BehaviorSubject<TSortDirections>(Direction.desc);
    this.updateSort = (sortKey: string) =>
      SortAndFilterService.updateSortCol(sortKey, this.sortKey$, this.sortDirection$);

    this.studentsSubscription = this.students$.pipe(takeUntil(this.destroy$)).subscribe(students => {
      this.students = students;
    });

    this.currentSelection = this.$stateParams.currentSelection;
    this.toolNameHuman = DASH_TO_HUMAN[this.currentSelection];
    this.syncedSheetsSelected = this.isSyncedSheet(this.toolNameHuman);
    if (this.syncedSheetsSelected) {
      this.currentOptions = this.readySyncs;
      this.columns = COLUMNS;
    } else {
      this.columns = SHEET_COLUMNS;
    }
    this.columnIndexMap = this.columnIndexMapper(this.columns);
    if (this.listContainerComponent) this.destroyComponent(this.listContainerComponent);
    this.pageHeaderMeta = this.initPageHeaderMeta(this.toolNameHuman);
    this.canAccessSync = this.userCanAccessSync(this.currentUser);
    this.internalViews = this.getInternalViewsUserCanAccess(this.currentUser, this.currentSchool.schoolType);
    this.toolsSubscription = this.tools$.pipe(takeUntil(this.destroy$)).subscribe(toolsList => {
      this.getExternalTools({
        tools: toolsList,
        currentUser: this.currentUser,
        internalViews: this.internalViews,
        canAccessSync: this.canAccessSync,
      });
      this.groupedTools = groupBy(toolsList, tool => {
        return tool.metaData.sheetToolType;
      });
    });
    this.groupings = this.syncedSheetsSelected
      ? this.groupSyncs([...this.pendingSyncs, ...this.readySyncs])
      : this.groupSheets(this.filterSheets(this.sheetTools, this.toolNameHuman));
    this.groupingData$.next(this.groupings);
    this.onFixed = () => {
      this.listContent.nativeElement.classList.remove('infinite');
      this.pageHeaderMeta = { ...this.pageHeaderMeta, ...{ icon: null } };
    };
    this.onInfinite = (instance: ComponentRef<any>) => {
      this.listContent.nativeElement.classList.add('infinite');
      this.pageHeaderMeta = { ...this.pageHeaderMeta, ...{ icon: this.getInfiniteHeaderIcon(instance) } };
    };
    this.onRowClick = this.goToSheet;
  }

  ngAfterViewInit(): void {
    this.createListContainer();
  }

  columnIndexMapper(columns): { [key: string]: number } {
    const columnMap = columns.reduce((mapping, col: IColumnStuLvl, i: number) => {
      mapping[col.graphQlKey] = i;
      return mapping;
    }, {});
    return columnMap;
  }

  isSyncedSheet(toolNameHuman): boolean {
    return toolNameHuman === 'Synced sheets' ? true : false;
  }

  filterSheets(sheetTools, toolNameHuman): IToolMini[] {
    const filteredSheets = filter(sheetTools, sheet => {
      return SHEET_TYPE_MAPPINGS[sheet.groupName] === toolNameHuman;
    });
    return filteredSheets;
  }

  goToSheet(rowData: IRowData[]): void {
    const row = find(rowData, 'meta');
    this.goExternal(row.meta.url);
  }

  private groupSheets(sheets: IToolMini[]): IGroupData[] {
    const groupedSheets = groupBy(sheets, sheet => {
      return sheet.schoolYear;
    });
    const years = Object.keys(groupedSheets)
      .sort()
      .reverse();
    return map(years, year => {
      const sheets = groupedSheets[year];
      const rowData = map(sheets, sheet => {
        const fileCol = {
          columnKey: 'FILE_NAME',
          data: sheet.label,
          meta: {
            url: sheet.url,
          },
        };
        const dateCol = {
          columnKey: 'CREATED_ON',
          data: sheet.createdOn,
          meta: {
            url: sheet.url,
          },
        };
        return [fileCol, dateCol];
      });
      return {
        key: year,
        human: year,
        tooltip: '',
        rowData,
      };
    });
  }

  private groupSyncs(syncs: ISync[]): IGroupData[] {
    const groupedSyncs = groupBy(syncs, sync => {
      return sync.schoolYear;
    });
    const years = Object.keys(groupedSyncs)
      .sort()
      .reverse();
    return map(years, year => {
      const syncs = groupedSyncs[year];
      const rowData = map(syncs, sync => {
        const fileCol = {
          columnKey: 'FILE_NAME',
          data: sync.sheetName,
          sync: sync.pending,
          meta: {
            url: sync.sheetLink,
          },
        };
        const createdByCol = {
          columnKey: 'CREATOR_NAME',
          data: sync.sheetCreator,
          sync: sync.pending,
          meta: {
            url: sync.sheetLink,
          },
        };
        const dateOrTrashColStr = sync.pending ? 'Generating...' : sync.createdDate;
        const dateCol = {
          columnKey: 'CREATED_ON',
          data: dateOrTrashColStr,
          sync: sync.pending,
          meta: {
            url: sync.sheetLink,
          },
        };
        const trashCol = {
          columnKey: '',
          data: sync.ownByCurrentUser,
          meta: {
            dynamic: true,
            syncId: sync.sheetId,
            dynamicColType: 'TRASH',
            sheetId: sync.sheetId,
            currentSchoolId: this.currentSchool._id,
            name: sync.sheetName,
          },
        };
        return [fileCol, createdByCol, dateCol, trashCol];
      });
      return {
        key: year,
        human: year,
        tooltip: '',
        rowData,
      };
    });
  }

  updateView(option): void {
    const dashCasedOption = HUMAN_TO_DASH[option];
    this.$state.go('main.school.other-tools', { currentSelection: dashCasedOption });
  }

  goExternal($url: string): void {
    const window = this.windowRef.nativeWindow;
    window.open($url, '_blank');
  }

  openSyncedSheetsModal(payload?: ISyncedSheetModalPayload): void {
    const firstPayload = payload ? payload : { schoolId: this.currentSchool._id, allStudents: this.students };
    this.modalSubscription = this.modalsService
      .createSyncedSheetModal(firstPayload)
      .afterClosed()
      .subscribe((firstResponse: ISyncedSheetModalPayload) => {
        if (firstResponse) {
          firstResponse.schoolAssessments$ = this.schoolAssessments$;
          this.syncedSheetColModalSub = this.modalsService
            .createSyncedSheetColumnsModal(firstResponse)
            .afterClosed()
            .subscribe(secondResponse => {
              if (secondResponse && secondResponse.goBack) {
                this.openSyncedSheetsModal(firstResponse);
              } else if (secondResponse && secondResponse.syncCreated) {
                this.modalsService.openAlertModal({
                  title: 'New synced sheet',
                  message: 'Your Google sheet is in the works. You will be notified by email when it is ready.',
                });
              }
            });
        }
      });
  }

  userCanAccessSync(currentUser: IUser): boolean {
    const isAdmin = this.imUser.isEditingUser(currentUser);
    const hasGafeEmail = !!this.imUser.getGafeEmail(currentUser);
    const gafeEmailDomain = this.imUser.getGafeEmailDomain(currentUser);
    const domainIsSyncEnabled = includes(SYNC_ENABLED_DOMAINS, gafeEmailDomain);
    return isAdmin && hasGafeEmail && domainIsSyncEnabled;
  }

  getInternalViewsUserCanAccess(currentUser: IUser, currentSchoolType: TValidSchoolTypes): IInternalView[] {
    const internalViewsForSchoolType = this.getInternalViewsForSchoolType(currentSchoolType);
    const filtered = map(internalViewsForSchoolType, (view: IInternalView) => {
      const { state } = view;
      if (state) {
        const userCanAccessState = this.imUser.canAccessState(currentUser, state);
        if (userCanAccessState) {
          return view;
        }
      }
    });
    return filtered;
  }

  getInfiniteHeaderIcon(instance: any) {
    const handler = () => (instance.aniState = 'collapsed');
    return {
      name: 'close',
      tooltip: 'Close',
      handler,
    };
  }

  private getInternalViewsForSchoolType(schoolType: TValidSchoolTypes): IInternalView[] {
    const validHighSchoolTypes: TValidSchoolTypes[] = ['Small HS', 'Large HS', '6 to 12', 'Transfer'];
    const currentSchoolIsHs = includes(validHighSchoolTypes, schoolType);
    if (currentSchoolIsHs) return hsInternalViews;
    else return [];
  }

  userHasToolsToDisplay(sheetTools: IToolMini[], internalViews: IInternalView[], canAccessSync: boolean): boolean {
    return Boolean(sheetTools.length || internalViews.length || canAccessSync);
  }

  getExternalTools({ tools, currentUser, internalViews, canAccessSync }: IExternalView): void {
    this.sheetTools = this.loadSheetTools(tools);
    this.hasTools = this.userHasToolsToDisplay(this.sheetTools, internalViews, canAccessSync);
    if (canAccessSync) {
      this.loadSyncs(tools, currentUser);
    }
  }

  loadSheetTools(tools: ITool[]): IToolMini[] {
    const sheetTools = tools.filter(tool => tool.toolType === 'SHEET');
    const sheetToolMinis = sheetTools.map(tool => {
      const sheetToolType = tool.metaData && tool.metaData.sheetToolType;
      const schoolYear = tool.metaData && tool.metaData.schoolYear;
      const createdDate = this.imTool.getCreatedOn(tool);
      // entries before SY18-19 were not instantiated with a createdOn field (SR)
      const createdDateOrDash = createdDate ? this.dateHelpers.getFormattedMoment(createdDate, 'MMM D, YYYY') : '-';
      return {
        label: this.imTool.getHumanName(tool),
        url: this.imTool.getSheetUrl(tool),
        createdOn: createdDateOrDash,
        schoolYear,
        groupName: this.utilitiesService.toTitleCase(sheetToolType),
      };
    });
    const orderedSheetToolMinis = orderBy(
      sheetToolMinis,
      ['schoolYear', 'groupName', 'label', 'createdOn'],
      ['asc', 'desc', 'asc', 'desc'],
    );
    return orderedSheetToolMinis;
  }

  loadSyncs(tools: ITool[], currentUser: IUser): void {
    const readySyncsUnordered = [];
    const pendingSyncsUnordered = [];
    tools.forEach(tool => {
      if (tool.toolType === 'SYNCED_SHEET' && !tool.deleted) {
        let pendingSync = this.makePendingSync(tool, currentUser);
        if (tool.metaData.spreadsheetId) {
          const readySync = Object.assign(pendingSync, {
            pending: false,
            sheetId: tool.metaData.spreadsheetId,
            sheetLink: this.imTool.getSheetUrl(tool),
          });
          readySyncsUnordered.push(readySync);
        } else {
          pendingSync = Object.assign(pendingSync, {
            pending: true,
          });
          pendingSyncsUnordered.push(pendingSync);
        }
      }
    });
    this.setReadyAndPendingSyncs(readySyncsUnordered, pendingSyncsUnordered);
    this.groupings = this.groupSyncs([...this.pendingSyncs, ...this.readySyncs]);
    this.groupingData$.next(this.groupings);
  }

  private makePendingSync(tool: ITool, currentUser: IUser): ISync {
    const sheetName = this.imTool.getHumanName(tool);
    // match MM-DD-YYYY h:mm a to correctly sort date through lodash.orderBy (JChu)
    const matched = sheetName.match(/[0-9]{2}-[0-9]{2}-[0-9]{4}\s[0-9]?[0-9]:[0-9]{2}\s(am|pm)/gi);
    const normalizedSheetName = this.normalizeSheetName(matched, sheetName);
    const sheetCreator = `${tool.createdBy.firstName} ${tool.createdBy.lastName}`;
    const sheetCreatorLowerCase = sheetCreator.toLowerCase();
    const createdDate = tool.createdAt;
    const normalizedCreatedDate = new Date(createdDate).getTime().toString();
    const ownByCurrentUser = this.imUser.getGafeEmail(currentUser) === this.imTool.getGafeEmail(tool);
    const schoolYear = tool.metaData.schoolYear;
    const pendingSync = {
      sheetName,
      normalizedSheetName,
      sheetCreator,
      sheetCreatorLowerCase,
      createdDate,
      normalizedCreatedDate,
      ownByCurrentUser,
      schoolYear,
    };
    return pendingSync;
  }

  private normalizeSheetName(matched, sheetName) {
    return matched
      ? replace(sheetName.toLowerCase(), matched[0], new Date(matched[0]).getTime().toString())
      : sheetName.toLowerCase();
  }

  private setReadyAndPendingSyncs(readySyncsUnordered, pendingSyncsUnordered): void {
    this.readySyncs = orderBy(readySyncsUnordered, ['normalizedSheetName', 'sheetCreatorLowerCase', 'createdAt']);
    this.pendingSyncs = orderBy(pendingSyncsUnordered, ['normalizedSheetName', 'sheetCreatorLowerCase', 'createdAt']);
  }

  initPageHeaderMeta(toolNameHuman): IPageHeaderMeta {
    return {
      title: toolNameHuman,
      subTitle: null,
    };
  }
}
